import { useTranslation } from "../../state/i18n";
import moreappBrandIcon from "../../assets/moreapp-icon-brand.svg";
import Layout from "../Layout";
import Section from "../Section";

const InviteAcceptanceErrorState = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <Section fullHeight={false} centerOnMobile>
        <div class="w-full mobile:p-6">
          <img
            src={moreappBrandIcon}
            alt={t(($) => $.MOREAPP_LOGO_IMG_ALT)}
            class="mx-auto mb-10 size-12 mobile:mx-0"
          />
          <h1 class="mb-1 text-header-3xl text-primary">{t(($) => $.INVITE_PAGE_INVALID_TITLE)}</h1>
          <p class="text-medium-regular text-secondary">{t(($) => $.INVITE_PAGE_INVALID_DESCRIPTION)}</p>
        </div>
      </Section>
    </Layout>
  );
};

export default InviteAcceptanceErrorState;
